import PlanAPI from '../../api/plan';
import { throwErrorMessage } from '../utils/api';

export const state = {
  entitlements: {
    plan: null,
    features: [],
    meters: {},
    billingEnabled: false,
  },
  plans: [],
  subscription: {
    plan: null,
    status: 'none',
    currentPeriodEnd: null,
  },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getEntitlements(_state) {
    return _state.entitlements;
  },
  getPlans(_state) {
    return _state.plans;
  },
  getSubscription(_state) {
    return _state.subscription;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  fetch: async ({ commit }) => {
    commit('setUIFlag', { isFetching: true });
    try {
      const [entitlements, plans, subscription] = await Promise.all([
        PlanAPI.getEntitlements(),
        PlanAPI.getPlans(),
        PlanAPI.getSubscription(),
      ]);
      commit('setEntitlements', entitlements.data);
      commit('setPlans', plans.data);
      commit('setSubscription', subscription.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  checkout: async (_, planSlug) => {
    const response = await PlanAPI.checkout(
      planSlug,
      window.location.href,
      window.location.href
    );
    window.location.href = response.data.url;
  },

  openPortal: async () => {
    const response = await PlanAPI.portal(window.location.href);
    window.location.href = response.data.url;
  },
};

export const mutations = {
  setUIFlag(_state, flag) {
    _state.uiFlags = { ..._state.uiFlags, ...flag };
  },
  setEntitlements(_state, data) {
    _state.entitlements = {
      plan: data.plan,
      features: data.features || [],
      meters: data.meters || {},
      billingEnabled: data.billing_enabled,
    };
  },
  setPlans(_state, data) {
    _state.plans = data;
  },
  setSubscription(_state, data) {
    _state.subscription = {
      plan: data.plan,
      status: data.status,
      currentPeriodEnd: data.current_period_end,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
